import React, { Component } from 'react';
import Cabecalho from '../componentes/Cabecalho';
import Rodape from '../componentes/Rodape';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import InputMask from 'react-input-mask';
import TextField from '@material-ui/core/TextField';
import { id_firebase } from '../content-site';
import { firestore } from './../firebase-config';
import FloatingWhatsApp from '../componentes/WhatsAppFlutuante';
import { sendEmailFinancial } from '../utils/emailUtils';


class Financiamento extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dados_financiamento: '',
            cpf: '',
            nome: '',
            data_nascimento: '',
            rg: '',
            sexo: '',
            estado_civil: '',
            naturalidade: '',
            naturalidade_uf: '',
            telefone: '',
            celular: '',
            nome_pai: '',
            nome_mae: '',
            cep_residencial: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            cidade_uf: '',
            empresa_trabalha: '',
            cargo: '',
            tempo_servico: '',
            com_cep: '',
            com_endereco: '',
            com_numero: '',
            com_complemento: '',
            com_bairro: '',
            com_cidade: '',
            com_uf: '',
            ref1_nome: '',
            ref1_telefone: '',
            ref2_nome: '',
            ref2_telefone: '',
            banco1_banco: '',
            banco1_agencia: '',
            banco1_conta: '',
            banco1_tempo_conta: '',
            banco2_banco: '',
            banco2_agencia: '',
            banco2_conta: '',
            banco2_tempo_conta: '',
            enviado: false,
            msg_enviado: '',
            revenda: {},
        }
        this.mounted = false;

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        window.scrollTo(0, 0);

        this.mounted = true;

        firestore.collection("revenda").doc(id_firebase)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        revenda: doc.data(),
                    });
                }
            }).catch(function (error) {
            });

    }

    handleSubmit = (event) => {
        event.preventDefault();
        sendEmailFinancial(this.state, this.setState.bind(this));
    };

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Cabecalho revenda={this.state.revenda} />
                {/*<FloatingWhatsApp />*/}

                <section>
                    <div className="container">
                        <div className="row text-center intro-title">
                            <div className="col-md-12 text-md-left d-inline-block">
                                <h1 className="text-black">FINANCIAMENTO</h1>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="form-financiamento">
                    <section className="b-contacts s-shadow">
                        <div className="container">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="b-contacts__form ">
                                        <header className="b-contacts__form-header s-lineDownLeft wow zoomInUp" data-wow-delay="0.5s">
                                            <h2 className="s-titleDet">Solicite uma simulação de financiamento</h2>
                                        </header>
                                        <p className=" wow zoomInUp" data-wow-delay="0.5s">Envie seus dados para simularmos um financimento. Em breve retornaremos o contato.</p>
                                        <ValidatorForm id="contactForm" className="s-form wow zoomInUp" ref="form" onSubmit={this.handleSubmit} >
                                            <h3>CARRO DE INTERESSE</h3>
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <textarea name="dados_financiamento" placeholder="DESCREVA OS DADOS DO CARRO QUE VOCÊ DESEJA FINANCIAR, BEM COMO O VALOR DO MESMO E AS CONDIÇÕES DO FINANCIAMENTO (ENTRADA, PARCELAS, TROCA DE CARRO, ETC.)" onChange={this.handleChange} ></textarea>
                                                </div>
                                            </div>
                                            <h3>DADOS PESSOAIS</h3>
                                            <div className="row">
                                                <div className="col-xs-3">
                                                    <InputMask
                                                        mask="999.999.999-99"
                                                        value={this.state.cpf}
                                                        label="CPF"
                                                        name="cpf"
                                                        onChange={this.handleChange}
                                                    >
                                                        {() => <TextField
                                                            label="CPF"
                                                            name="cpf"
                                                            type="text"
                                                            className="form-ui-bootstrap"
                                                        />}
                                                    </InputMask>
                                                </div>
                                                <div className="col-xs-6">
                                                    <TextValidator
                                                        label="NOME COMPLETO *"
                                                        onChange={this.handleChange}
                                                        name="nome"
                                                        value={this.state.nome}
                                                        className="form-ui-bootstrap"
                                                        validators={['required']}
                                                        errorMessages={['Preenchimento obrigatório']}
                                                    />
                                                </div>
                                                <div className="col-xs-3">
                                                    <InputMask
                                                        mask="99/99/9999"
                                                        value={this.state.data_nascimento}
                                                        label="DATA DE NASCIMENTO"
                                                        name="data_nascimento"
                                                        onChange={this.handleChange}
                                                    >
                                                        {() => <TextField
                                                            label="DATA DE NASCIMENTO"
                                                            name="data_nascimento"
                                                            type="text"
                                                            className="form-ui-bootstrap"
                                                        />}
                                                    </InputMask>
                                                </div>
                                                <div className="col-xs-6">
                                                    <TextValidator
                                                        label="NOME COMPLETO DA MÃE"
                                                        onChange={this.handleChange}
                                                        name="nome_mae"
                                                        value={this.state.nome_mae}
                                                        className="form-ui-bootstrap"
                                                    />
                                                </div>
                                                <div className="col-xs-8">
                                                    <TextValidator
                                                        label="CIDADE"
                                                        onChange={this.handleChange}
                                                        name="com_cidade"
                                                        value={this.state.com_cidade}
                                                        className="form-ui-bootstrap"
                                                    />
                                                </div>

                                                <div className='formDaCo'><h3>DADOS PARA CONTATO</h3></div>

                                                <div className="col-xs-9">
                                                    <TextValidator
                                                        label="E-MAIL"
                                                        onChange={this.handleChange}
                                                        name="ref1_nome"
                                                        value={this.state.ref1_nome}
                                                        className="form-ui-bootstrap"
                                                    />
                                                </div>
                                                <div className="col-xs-3">
                                                    <InputMask
                                                        mask="(99) 99999-9999"
                                                        value={this.state.ref1_telefone}
                                                        label="TELEFONE *"
                                                        name="ref1_telefone"
                                                        onChange={this.handleChange}
                                                    >
                                                        {() => <TextField
                                                            label="TELEFONE (WHATSAPP) *"
                                                            name="ref1_telefone"
                                                            type="text"
                                                            className="form-ui-bootstrap"
                                                        />}
                                                    </InputMask>
                                                </div>
                                            </div>



                                            <button type="submit" className="btn m-btn">ENVIAR DADOS<span className="fa fa-angle-right"></span></button>
                                            {
                                                this.state.enviado &&
                                                <blockquote>
                                                    <p><em>{this.state.msg_enviado}</em></p>
                                                </blockquote>
                                            }
                                        </ValidatorForm>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Rodape revenda={this.state.revenda} />
            </div>
        )
    }
}

export default Financiamento